import Parcour from "./Parcour";
export default Parcour;
